export enum UserFormSteps {
  Phone = 'phone',
  Name = 'name'
}
